export default __webpack_public_path__ + "static/382-4948ae74db48c321a170c89a66f9cbee.gif";